if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');

      // Initialize dynamic height adjustments for mobile
      window.addEventListener('resize', () => this.adjustGalleryHeight());
      window.setTimeout(() => this.adjustGalleryHeight(), 100);

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const activeElement = event.detail.currentElement;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ activeElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
      this.adjustGalleryHeight(activeElement);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);
      this.adjustGalleryHeight(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    adjustGalleryHeight(activeMedia) {
      if (window.innerWidth >= 750) {
        if (this.elements.viewer) {
          const list = this.elements.viewer.querySelector('.product__media-list');
          if (list) {
            list.style.height = '';
            list.style.alignItems = '';
          }
        }
        return;
      }

      if (!activeMedia) {
        activeMedia = this.elements.viewer.querySelector('.product__media-item.is-active') ||
                      this.elements.viewer.querySelector('.product__media-item');
      }
      if (!activeMedia) return;

      const list = activeMedia.parentElement;
      if (!list) return;

      const containerWidth = activeMedia.offsetWidth;
      if (containerWidth <= 0) return;

      // 1. Try to get ratio from style attribute set by Liquid (--preview-ratio or --ratio)
      const container = activeMedia.querySelector('.product-media-container');
      let ratio = null;
      if (container) {
        const style = container.getAttribute('style') || '';
        const previewMatch = style.match(/--preview-ratio:\s*([0-9.]+)/);
        if (previewMatch && previewMatch[1]) {
          ratio = parseFloat(previewMatch[1]);
        } else {
          const ratioMatch = style.match(/--ratio:\s*([0-9.]+)/);
          if (ratioMatch && ratioMatch[1]) {
            ratio = parseFloat(ratioMatch[1]);
          }
        }
      }

      const applyHeight = (r) => {
        if (r && r > 0) {
          const targetHeight = containerWidth / r;
          list.style.height = targetHeight + 'px';
          list.style.alignItems = 'flex-start';
          list.style.overflowY = 'hidden';
          return true;
        }
        return false;
      };

      if (applyHeight(ratio)) return;

      // 2. Fallback to image natural dimensions if ratio wasn't parsed
      const activeImg = activeMedia.querySelector('img');
      if (activeImg) {
        const adjustFromImg = () => {
          const imgRatio = activeImg.naturalWidth / activeImg.naturalHeight;
          applyHeight(imgRatio);
        };

        if (activeImg.complete) {
          adjustFromImg();
        } else {
          activeImg.addEventListener('load', adjustFromImg);
        }
      }
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
